import { Container } from './styles'
import { FaInstagram, FaFacebookF, FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import logo from '../../assets/logo.png'

export const Footer = () => {


  return (
    <Container>
      <div className='footer'>
        <div className='footer-top'> 
          <div className='footer-logo'>
          <div className='logo'>
                <a href='/'>
                    <img src={logo} alt="logomarca da página" />
                </a>
            </div>
            <p>Escolha seu pacote, selecione um destino que sempre quis conhecer e Vai de Férias!</p>
            <div className='footer-social'>
              <a href='#'><FaInstagram /></a>
              <a href='#'><FaFacebookF /></a>
              <a href='#'><FaLinkedinIn /></a>
              <a href='#'><FaTwitter /></a>
            </div>
          </div>
          <div className='footer-heading footer-1'>
            <h2>Parceiros</h2>
            <a href='#'>Item 1</a>
            <a href='#'>Item 2</a>
            <a href='#'>Item 3</a>
            <a href='#'>Item 4</a>
          </div>
          <div className='footer-heading footer-2'>
            <h2>Saiba mais</h2>
            <a href='#'>Item 1</a>
            <a href='#'>Item 2</a>
            <a href='#'>Item 3</a>
            <a href='#'>Item 4</a>
          </div>
          <div className='footer-heading footer-3'>
            <h2>Dúvidas</h2>
            <a href='#'>Item 1</a>
            <a href='#'>Item 2</a>
            <a href='#'>Item 3</a>
            <a href='#'>Item 4</a>
          </div>
          <div className='footer-heading footer-4'>
            <h2>Pagamentos</h2>
            <a href='#'>Item 1</a>
            <a href='#'>Item 2</a>
            <a href='#'>Item 3</a>
            <a href='#'>Item 4</a>
          </div>
        </div>
        <div className='footer-bottom'>
          <p>2021 AMERIS. Todos os direitos reservados. Feito por 
            <a href="http://www.struct.unb.br/">{' {'}Struct{'}'}</a>
          </p>
        </div>
      </div>
    </Container>
  )
}